import { isMerchant } from '../env'

export async function createRouter(_ctx) {
  const router = isMerchant
    ? (await import('./merchant.js')).createRouter(_ctx)
    : (await import('./admin.js')).createRouter(_ctx)
  return router
}
